import {
  FETCH_HUBS_REQUEST,
  CREATE_HUB_REQUEST,
  UPDATE_HUB_REQUEST,
  DELETE_HUB_REQUEST,
  UPLOAD_HUB_REQUEST,
  UPGRADE_HUB_REQUEST
} from './constants'

export function fetchHubs() {
  return {type: FETCH_HUBS_REQUEST}
}

export function postHub(newHubState) {
  return {type: CREATE_HUB_REQUEST, newHubState}
}

export function updateHub(updateHubState) {
  return {type: UPDATE_HUB_REQUEST, updateHubState}
}

export function deleteHub(deleteHubState) {
  return {type: DELETE_HUB_REQUEST, deleteHubState}
}

export function uploadHub(newFirmwareState) {
  return {type: UPLOAD_HUB_REQUEST, newFirmwareState}
}

export function upgradeHub(newUpgradeListState) {
  return {type: UPGRADE_HUB_REQUEST, newUpgradeListState}
}



// WEBPACK FOOTER //
// ./src/actions/hub.js